export const minOfDepartureDateSearch = '01-01-2021';
